module.exports = __webpack_public_path__ + "static/media/card-empty-holidays.f9c94977.png";